<template>
    <div class="h-screen w-full bg-blue flex items-center justify-center fixed pin-t pin-l">
        <div class="max-w-sm w-full mx-2">
            <div class="flex justify-center pb-8 mb-8">
                <logo style="max-width:120px"></logo>
            </div>
            <div v-if="loading">
                <div class="spinner-white"></div>
                <div class="py-8 text-center text-white font-heading uppercase text-sm font-bold">
                    Checking token
                </div>
            </div>
            <div v-if="!valid && !loading" class="flex items-center justify-center text-center">
                <div>
                <span :class="`inline-flex h-12 w-12 border-2 border-white text-2xl text-white rounded-full items-center justify-center mb-8`">
                    <i :class="'fal fa-times'"></i>
                </span>
                    <p class="text-white">
                        This token is invalid.<br><br>
                        It might have already been used or it has expired.
                    </p>
                </div>
            </div>
            <form @submit.prevent="submit" v-if="!loading && valid">
                <h2 class="text-center text-white mb-8">Set a new password</h2>

                <form-group name="password" label="Password" :required="true" :invert="true">
                    <input type="password" name="password" id="password" class="input input--invert text-white"
                           v-model="password">
                </form-group>

                <form-group name="password_confirmation" label="Repeat Password" :required="true" :invert="true">
                    <input type="password" name="password_confirmation" id="password_confirmation"
                           class="input input--invert text-white"
                           v-model="password_confirmation">
                </form-group>

                <div class="flex py-8 items-center flex-col md:flex-row">
                    <div class="flex-1 text-center">
                        <brand-button type="submit" color="invert">Set Password</brand-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'

    export default {
        data() {
            return {
                loading: true,
                valid: false,
                password: null,
                password_confirmation: null,
                errors: {}
            }
        },

        mounted() {
            this.$api().get('password/reset?token=' + this.$route.params.token).then(({data}) => {
                this.loading = false
                this.valid = true
            }).catch(() => {
                this.valid = false
                this.loading = false
            })
        },

        methods: {
            submit() {
                this.loading = true
                this.$api().post('password/reset?token=' + this.$route.params.token, {
                    password: this.password,
                    password_confirmation: this.password_confirmation
                }).then(({data}) => {
                    setTimeout(() => {
                        this.$router.replace('/login')
                        this.$noty.success('Password reset. Please log in.')
                    }, 500)
                }).catch(() => {
                    setTimeout(() => {
                        this.valid = true
                        this.loading = false
                    }, 500);
                })
            }
        },
    }
</script>
